import React from 'react';

import './HtmlBox.scss';
import Icon from 'Core/Components/Icon';

class HtmlBox extends React.Component {
  constructor (props) {
    super(props);
    this.state = { isFocus: false, hasBlurred: true }
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);;
    this.handleChange = this.handleChange.bind(this);
    this.triggerUpdate = this.triggerUpdate.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  triggerUpdate (value) {
    const { onChange } = this.props;
    if (typeof onChange !== 'function') return;
    return onChange(value);
  }

  handleChange (event) {
    this.triggerUpdate(event.target.value);
  }

  handleBlur () {
    const isFocus = false;
    const hasBlurred = true;
    this.setState({ isFocus, hasBlurred });
  }

  handleFocus () {
    const isFocus = true;
    this.setState({ isFocus });
  }

  handleKeyDown (event) {
    const { key, target } = event;
    if (key === 'Tab') {
      event.preventDefault();
      const { value } = this.props;
      const start = target.selectionStart;
      const end = target.selectionEnd;
      const preTab = value.substring(0, start)
      const postTab = value.substring(end);
      const newText = `${preTab}\t${postTab}`;
      this.triggerUpdate(newText);
      setTimeout(() => {
        this.refs.input.selectionStart = start + 1;
        this.refs.input.selectionEnd = start + 1;
      }, 0);
    }
  }

  render () {
    const { isFocus, hasBlurred } = this.state;
    const { value, label, onChange, icon, disabled, rows, required, className, tabIndex } = this.props;
    return (
      <div className={'Field HtmlBox-Wrapper' + (className ? ' ' + className : '')}>
        <div className={'HtmlBox' + (disabled ? ' disabled' : '')}>
          <box className="HtmlBox-Heading">
            {!icon ? null : (
              <box className="HtmlBox-Icon">
                <Icon fa={icon + (isFocus ? ' active' : '')} />
              </box>
            )}
            {!label ? null : (
              <label>
                {label}
                {!required ? '' : <span style={{ opacity: 0.4 }}>*</span>}
              </label>
            )}
          </box>
          <box className="HtmlBox-Field">
            <textarea
              tabIndex={tabIndex || 0}
              disabled={disabled}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              value={value ? value : ''}
              rows={rows ? rows : 10}
              ref="input"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
            />
          </box>
        </div>
      </div>
    )
  }
};

export default HtmlBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/HtmlBox/HtmlBox.jsx